import { i18n } from 'next-i18next'
import { Config } from 'modules/config/state/config-types'
import { FlowStep } from '../../flow-types'
import { INITIAL_INVALID_STEP_INDEX, INITIAL_NUM_VISITS } from './constants'

export const ADDITIONAL_DONOR_INFORMATION_STEP_NAME = 'additional-donor-information'

export const makeAdditionalDonorInformationStep = (config: Config): FlowStep => {
  const t = i18n?.t.bind(i18n) || ((key: string, fallback: string) => fallback)

  const hasOptionalContactQuestions = config.questions.contact.some(
    (question) => !question.is_required,
  )

  return {
    name: ADDITIONAL_DONOR_INFORMATION_STEP_NAME,
    title: t('AdditionalInformationStep.title', 'Additional Information'),
    enabled: hasOptionalContactQuestions,
    index: INITIAL_INVALID_STEP_INDEX,
    numVisits: INITIAL_NUM_VISITS,
    layout: 'flow-one-column',
  }
}
